<h1 class="page-title">Change Password</h1>
<form *ngIf="!changePasswordSuccess" class="form sign-in-form" [formGroup]="changePasswordForm"
      (ngSubmit)="onSubmit(changePasswordForm.value)">
  <p class="form__description">Enter a new password for your account.</p>
  <div class="field ">
    <label for="oldPassword" class="label">Old Password</label>
    <input class="input" formControlName="oldPassword" id="oldPassword" name="oldPassword" type="password"
           placeholder="" autocomplete="off" required/>
    <div *ngIf="formMessages.oldPassword" class="error-message field__error-message">{{ formMessages.oldPassword }}
    </div>
  </div>
  <div class="field ">
    <label for="newPassword" class="label">New Password</label>
    <input class="input" formControlName="newPassword" id="newPassword" name="newPassword" type="password"
           placeholder="" autocomplete="off" required/>
    <div *ngIf="formMessages.newPassword" class="error-message field__error-message">{{ formMessages.newPassword }}
    </div>
  </div>
  <div class="field ">
    <label for="confirmation" class="label">Retype Password</label>
    <input class="input" formControlName="confirmation" id="confirmation" appValidateEqual="newPassword"
           name="confirmation" type="password" placeholder="" autocomplete="off" required/>
    <div *ngIf="formMessages.confirmation" class="error-message field__error-message">{{ formMessages.confirmation }}
    </div>
  </div>
  <div *ngIf="formError" class="error-message field__error-message">{{formError}}</div>
  <input class="button" type="submit" value="Change Password">
</form>
<div *ngIf="changePasswordSuccess">
  <p>Your password has been changed successfully.</p>
  <button type="button" class="button" routerLink="/">Continue</button>
</div>
